import { query } from "@solidjs/router";
import { getPermissions } from "./getPermissions";

export const getPermissionsCacheFn = query(
  () => getPermissions(),
  "permission-set"
);
